// Cidade do perfil: um campo de busca na lista do IBGE, sem acento e sem diferença de maiúsculas, que mostra
// "Carapicuíba · SP" e só aceita uma opção da lista. A lista (cerca de 150 KB) carrega quando o campo aparece.
import { useEffect, useId, useState } from 'react';
import { rotuloDoMunicipio, type Busca, type Municipio } from '@truco6/localidades';

let carregando: Promise<Busca> | null = null;
export const carregarCidades = () => (carregando ??= import('@truco6/localidades/municipios').then((m) => m.BUSCA));

export function useCidades(): Busca | null {
  const [busca, setBusca] = useState<Busca | null>(null);
  useEffect(() => { let vivo = true; void carregarCidades().then((b) => { if (vivo) setBusca(b); }); return () => { vivo = false; }; }, []);
  return busca;
}

// pendente: há texto digitado que ainda não é uma cidade da lista. O formulário não salva assim.
export function CampoCidade({ codigo, erro, aoMudar }: {
  codigo: number | null; erro: string | null; aoMudar: (codigo: number | null, pendente: boolean) => void;
}) {
  const busca = useCidades();
  const id = useId();
  const [texto, setTexto] = useState<string | null>(null); // null: mostra o rótulo da cidade escolhida
  const [aberto, setAberto] = useState(false);
  const [ativo, setAtivo] = useState(0);
  const escolhida = codigo && busca ? busca.porCodigo(codigo) : undefined;
  const valor = texto ?? (escolhida ? rotuloDoMunicipio(escolhida) : '');
  const opcoes = busca && texto ? busca.buscar(texto) : [];
  const mostrar = aberto && opcoes.length > 0;

  function escolher(m: Municipio) {
    setTexto(null); setAberto(false);
    aoMudar(m.codigo, false);
  }
  function digitar(t: string) {
    setTexto(t); setAberto(true); setAtivo(0);
    aoMudar(null, t.trim() !== '');
  }

  return (
    <div className="campo campo-cidade">
      <label htmlFor={id + '-entrada'}>Cidade</label>
      <input id={id + '-entrada'} role="combobox" aria-autocomplete="list" aria-expanded={mostrar} aria-controls={id + '-lista'}
        aria-activedescendant={mostrar ? `${id}-op-${ativo}` : undefined} aria-invalid={!!erro} aria-describedby={id + '-nota'}
        autoComplete="off" spellCheck={false} placeholder={busca ? 'Digite e escolha na lista' : 'Carregando cidades...'}
        value={valor} disabled={!busca}
        onChange={(ev) => digitar(ev.target.value)}
        onFocus={() => setAberto(true)}
        onBlur={() => {
          setAberto(false);
          // Nome que bate com uma única cidade vale como escolha da lista.
          const unica = texto && busca?.unicoPeloNome(texto);
          if (unica) escolher(unica);
        }}
        onKeyDown={(ev) => {
          if (!mostrar) return;
          if (ev.key === 'ArrowDown') { ev.preventDefault(); setAtivo((a) => (a + 1) % opcoes.length); }
          else if (ev.key === 'ArrowUp') { ev.preventDefault(); setAtivo((a) => (a - 1 + opcoes.length) % opcoes.length); }
          else if (ev.key === 'Enter') { ev.preventDefault(); escolher(opcoes[ativo]!); }
          else if (ev.key === 'Escape') setAberto(false);
        }} />
      {mostrar && (
        <ul className="opcoes-cidade" role="listbox" id={id + '-lista'} aria-label="Cidades">
          {opcoes.map((m, i) => (
            <li key={m.codigo} id={`${id}-op-${i}`} role="option" aria-selected={i === ativo}
              onMouseDown={(ev) => { ev.preventDefault(); escolher(m); }}>
              {m.nome} <span>· {m.uf}</span>
            </li>
          ))}
        </ul>
      )}
      {erro ? <small className="erro" id={id + '-nota'} role="alert">{erro}</small>
        : <small id={id + '-nota'}>Opcional. Escolha na lista do IBGE.</small>}
    </div>
  );
}
